import DtoInterface from "./DtoInterface";

export default class ProductDto implements DtoInterface {
  public id?: number;
  public name?: string;
  public type?: string;
  public image?: string;
  public description?: string;
  public priceCurrent?: number;
  public pricePrevious?: number;
  public moreInfo?: string
  public companyId?: string
  public pageId?: string

  public fromJson(json: any): void {
    this.id = json.id;
    this.name = json.name;
    this.type = json.type;
    this.image = json.image;
    this.description = json.description;
    this.priceCurrent = json.price_current;
    this.pricePrevious = json.price_previous;
    this.moreInfo = json.more_info;
    this.companyId = json.company_id;
    this.pageId = json.page_id;
  }

  toJson(): object {
    return {
      id: this.id,
      name: this.name,
      type: this.type,
      image: this.image,
      description: this.description,
      price_current: this.priceCurrent,
      price_previous: this.pricePrevious,
      more_info: this.moreInfo,
    }
  }
}